<template>
  <dialog class="modal" ref="modalRef">
    <div class="modal-box rounded-xl space-y-4">

      <!-- Header con tooltip y separador -->
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-2">
          <i class="bi bi-clipboard-check text-xl text-light"></i>
          <h3 class="font-semibold text-light text-lg">{{ title }}</h3>
        </div>

        <!-- Tooltip -->
        <div class="tooltip tooltip-left" data-tip="Choose one or more conditions">
          <i class="bi bi-question-circle text-light text-lg cursor-pointer"></i>
        </div>
      </div>

      <!-- Divider bajo el header -->
      <hr class="-mx-6 border-t border-gray-300"/>

      <FormLabel label="Select from the list" font="font-bold"/>

      <!-- Contenido: Lista de checkboxes -->
      <div class="space-y-3 max-h-64 overflow-y-auto pr-2">
        <label
            v-for="item in disclaimers"
            :key="item"
            class="flex items-center gap-3 cursor-pointer"
        >
          <input
              type="checkbox"
              v-model="selected"
              :value="item"
              class="checkbox checkbox-primary align-middle"
          />
          <span class="text-sm text-base-content leading-snug">{{ item }}</span>
        </label>
      </div>

      <hr class="-mx-6 border-t border-gray-300"/>

      <!-- Sección de botones -->
      <div class="flex justify-end gap-4 pt-4">
        <AButton
            v-for="(btn, index) in buttons"
            :key="index"
            :class="btn.class"
            @click="btn.action"
        >
          {{ btn.label }}
        </AButton>
      </div>
    </div>
  </dialog>
</template>

<script setup>
import {ref} from 'vue'
import AButton from "@/components/atoms/AButton.vue";
import FormLabel from "@/components/atoms/FormLabel.vue";

// Props y emits
const props = defineProps({
  disclaimers: Array,
  title: { type: String, default: 'Select Disclaimers' }
})
const emit = defineEmits(['confirmed'])

// Estado y referencias
const selected = ref([])
const modalRef = ref(null)

// Métodos públicos
function openModal() {
  selected.value = []
  modalRef.value?.showModal()
}

function closeModal() {
  modalRef.value?.close()
}

function confirmSelection() {
  emit('confirmed', selected.value)
  closeModal()
}

// Exponer funciones
defineExpose({
  openModal,
  closeModal
})

// Botones personalizados
const buttons = [
  {
    label: 'Cancel',
    class: 'btn btn-ghost min-w-[120px]',
    action: closeModal
  },
  {
    label: 'Continue',
    class: 'btn btn-primary min-w-[120px]',
    action: confirmSelection
  }
]
</script>